let d = window.define;
import "ember-compatibility-helpers/-embroider-implicit-modules.js";
import "ember-cli-typescript/-embroider-implicit-modules.js";